import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledChipContainer = styled.div`
    display: inline-flex;
    align-items: center;
`;

export const StyledDelimeter = styled(Text)`
    margin-right: 8px;
`;

const showMoreButtonStyles = css`
    height: 24px !important;
    padding: 0 12px;
    background-color: ${rgba(colorsPalettes.sky[500], 0.2)};
    color: ${colorsPalettes.blue[500]};
    ${setFontVariant("chip1")};
    margin: 4px 0;
    &:hover {
        background-color: ${colorsPalettes.sky[200]};
        color: ${colorsPalettes.blue[500]};
    }
    div {
        ${setFontVariant("chip1")};
    }
`;

export const StyledShowMoreIconButton = styled(IconButton)`
    ${showMoreButtonStyles};
`;
export const StyledShowMoreButton = styled(Button)`
    ${showMoreButtonStyles}
`;
